package com.klantenstop.web.data.models.dto.requests.curatedcity

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class InsertCuratedCity(
    val name: String = "",
    val province: String = "",
    val latitude: Double = 0.0,
    val longitude: Double = 0.0,
    val country: String = "BE",
    @SerialName("is_featured")
    val isFeatured: Boolean = false
) {
    val isValid get() = name.isNotBlank() && province.isNotBlank()
}
